import { TRANSACTION_LIST, TRANSACTION_GET, TRANSACTION_CREATE, TRANSACTION_SUBMIT, TRANSACTION_APPROVE, TRANSACTION_REJECT, TRANSACTION_WITHDRAW, TRANSACTION_POST, TRANSACTION_REPAIR, TRANSACTION_REPOST, TRANSACTION_REVERSE, TRANSACTION_LOTS, TRANSACTION_DISPOSALS, TRANSACTION_FACTS, } from '../../operations/operation-ids.js';
/**
 * Organization transaction operator: transaction lifecycle mutations within the
 * active organization, excluding regulatory and accounting admin actions.
 */
export const ORGANIZATION_TRANSACTION_OPERATOR_OPERATIONS = [
    TRANSACTION_LIST,
    TRANSACTION_GET,
    TRANSACTION_CREATE,
    TRANSACTION_SUBMIT,
    TRANSACTION_APPROVE,
    TRANSACTION_REJECT,
    TRANSACTION_WITHDRAW,
    TRANSACTION_POST,
    TRANSACTION_REPAIR,
    TRANSACTION_REPOST,
    TRANSACTION_REVERSE,
    TRANSACTION_LOTS,
    TRANSACTION_DISPOSALS,
    TRANSACTION_FACTS,
];
